import React from 'react';
import styles from './table-skeleton.module.css';

const TableSkeleton = ({ rows = 10, columns = 5 }) => {
  return (
    <div className={styles.skeletonContainer}>
      <table className={styles.skeletonTable}>
        <thead>
          <tr>
            {Array.from({ length: columns }).map((_, index) => (
              <th key={index}>
                <div className={styles.skeletonHeader}></div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <tr key={rowIndex}>
              {Array.from({ length: columns }).map((_, colIndex) => (
                <td key={colIndex}>
                  <div className={styles.skeletonCell}></div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableSkeleton;
